import React, { useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCompany } from '../contexts/CompanyContext';
import { supabase } from '../lib/supabase_client';

export default function PaymentCancel() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const purchaseId = searchParams.get('purchase_id');
  const { selectedCompany } = useCompany();

  const markAsFailed = useCallback(async () => {
    // Mark purchase as failed if we have the purchase_id
    if (purchaseId) {
      try {
        // ⚠️ Only downgrade purchases that are still pending/cancelled. The user can
        // land on this page AFTER the Billplz callback already confirmed payment
        // (back button, stale redirect, slow B2B bank flow) — a paid purchase must
        // never be overwritten to failed, or status desyncs from the granted credits.
        const { error } = await supabase
          .from('org_purchases')
          .update({
            status: 'failed',
            updated_at: new Date().toISOString()
          })
          .eq('id', purchaseId)
          .in('status', ['pending', 'cancelled']);

        if (error) {
          console.error('Error marking purchase as failed:', error);
        }
      } catch (error) {
        console.error('Error in markAsFailed:', error);
      }
    }
  
    // Redirect
    const timer = setTimeout(() => {
      if (selectedCompany?.company_id) {
        navigate(`/all-filings/${selectedCompany.company_id}`);
      } else {
        navigate('/dashboard');
      }
    }, 2000);
  
    return () => clearTimeout(timer);
  }, [purchaseId, selectedCompany?.company_id, navigate]);

  useEffect(() => {
  markAsFailed();
}, [markAsFailed]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center bg-white p-8 rounded-lg shadow-lg max-w-md">
        <div className="text-red-500 text-6xl mb-4">✕</div>
        <h2 className="text-2xl font-bold mb-2 text-gray-900">Payment Not Completed</h2>
        <p className="text-gray-600 mb-4">Your payment was not completed. No charges were made.</p>
        <div className="text-left bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
          <p className="text-sm font-medium text-blue-800 mb-1">Paid via corporate (B2B) banking?</p>
          <p className="text-sm text-blue-700">
            Your payment may still be awaiting approval from your account authorizer.
            Once your bank confirms, credits will be added automatically — no need to pay again.
          </p>
        </div>
        <p className="text-sm text-gray-500 mt-4">Redirecting...</p>
      </div>
    </div>
  );
}